export const getProductImage = (imageList: any) => {
	const defaultProductImage = 'images/vizio-logo-print.svg';
	const imageURL =
		imageList &&
		imageList.find(
			(image: any) => image.tag.includes('hero-1-mobile') || image.tag.includes('hero-mobile')
		);
	const productImage = imageURL && imageURL.url.split(/\/jcr:/)[0];

	return productImage ? productImage : defaultProductImage;
};

/**
 * Method to convert String time to Date ( 2:00 PM -> 14 )
 * Expecting input string to be like '1:00 AM', '2:57 PM'
 * @param timeString
 */
export const getHoursFromString = (timeString: string) => {
	const timeArray = timeString.split(' ');

	const hours = timeArray[0];
	const amPm = timeArray[1];

	const hoursArray = hours.split(':');
	let givenHour = parseInt(hoursArray[0]);
	const givenMinutes = hoursArray[1] ? parseInt(hoursArray[1]) : 0;

	if (amPm && amPm.toUpperCase() === 'PM') {
		givenHour += 12;
	}

	const resultDate = new Date(new Date().toLocaleString('en', { timeZone: 'America/Chicago' }));
	resultDate.setHours(givenHour);
	resultDate.setMinutes(givenMinutes);

	return resultDate;
};
